/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Open Full Screen Icon component.
 */
export const OpenFullScreenIcon = ({color, size, ...props}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox={`0 0 ${iconSize} ${iconSize}`} fill='none'>
      <path d='M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z' fill={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default OpenFullScreenIcon;
